import { useMemo } from "react";

const { useSubscription, gql } = require("@apollo/client");

/**
 * Wrapper function to import the apollo client
 * @returns The apollo client.
 */
export const useApolloClient = (): {
    /* eslint-disable  @typescript-eslint/no-explicit-any */
    useSubscription: (param1: any, param2: any) => any;
    /* eslint-disable  @typescript-eslint/no-explicit-any */
    gql: any;
} => {
    const client = useMemo(
        () => ({
            useSubscription,
            gql
        }),
        []
    );

    return client;
};
